export default {
  nav__site: "Site",
  nav__store: "Store",
  nav__market: "Market",
  nav__map: "Map",
  nav__support: "Support",
  nav__off_two_factor: "Turn off two factor authenticate",
  nav__on_two_factor: "Turn on two factor authenticate",
  nav__log_out: "Log out",
  nav__select_a_language: "Select a language",
  nav__notification: "Notification",

  action__apply: "Apply",
  action__close: "Close",
  action__default: "Default",
  action__cancel: "Cancel",
  action__go_back: "Go back",
  action__continue: "Next",
  action__edit: "Edit",
  action__save_and_preview: "Save and preview",
  action__create_new: "Create new",
  action__add_owner: "Add home owner",
  action__add_update: "Add update",
  action__other_feature: "Other features",
  action__traffic: "Traffic",
  action__compare: "Site comparison",
  action__hide: "Hide",
  action__convert_to_store: "Convert to store",
  action__save: "Save",
  action__save_and_continue: "Save & continue editing",
  action__save_and_calculation: "Save & Calculate",
  action__post: "Post",
  action__posting: "Posting",
  action__create_contract: "Create contract",
  action__show: "Show",
  action__add: "Add",
  action__yes: "Yes",
  action__no: "No",
  action__remove: "Remove",
  action__delete: "Delete",
  action__done: "Done",
  action_saving: "Saving",
  action__confirm: "Confirm",
  action_view__site_detail: "View site detail",

  home__site_listing: "Site management",
  home__my_site: "My sites",
  home__store_listing: "Store management",
  home__market_info: "Market Information",
  home__site_planning_zone: "Planning zone",
  home__old_map: "Old map",
  home__change_password: "Change password",
  home__settings: "Settings",

  site_listing__site: "Sites",
  site_listing__all: "All",
  site_listing__status: "Status",
  site_listing__search_name_placeholder: "Site name, address...",
  site_listing__city: "City",
  site_listing__assignee: "Assignee",
  site_listing__select_column_to_display: "Select columns to display",
  site_listing__create_new_site: "Create new site",
  site_listing__site_name: "Site name",
  site_listing__address: "Address",
  site_listing__created_by: "Created by",
  site_listing__site_owner_reply_due_date: "Reply due date",
  site_listing__created_on: "Created on",
  site_listing__reverse_reason: "Reverse reason",
  site_listing__filter_column_table_label: "Filter displayed information",
  site_listing__filter_show_all: "Show all",
  site_listing__reverse_placeholder: "Enter reason",

  modal_create_site__title: "New site information",
  modal_create_site__store_type: "Store type",
  modal_create_site__store_format: "Store format",

  site_detail__assignment: "Assignees",
  site_detail__follower: "Followers",
  site_detail__processing: "Process",
  site_detail__tab_summary: "Summary",
  site_detail__tab_general: "General",
  site_detail__tab_photo: "Photo",
  site_detail__tab_legal_document: "Legal & Document",
  site_detail__tab_rental_information: "Rental information",
  site_detail__tab_financial_projection: "Financial prediction",
  site_detail__tab_comment: "Comment",
  site_detail__tab_activity: "Activity",
  site_detail__tab_changelog: "Changelog",
  site_detail__tab_external_dashboard: "External dashboard",
  site_detail__tab_contract: "Contract",

  site_summary_tab__site_map: "Site map",
  site_summary_tab__pricing: "Pricing",
  site_summary_tab__initial_lease_rate: "monthly rental rate",
  site_summary_tab__calculation_method: "Calculation method",
  site_summary_tab__lease_term_year: "Years of rent (on contract)",
  site_summary_tab__increase_rate_year_period: "Cycle of increasing rate",
  site_summary_tab__estimate_cannibalization: "Cannibalization estimation",
  site_summary_tab__area_and_size: "Size & Area",
  site_summary_tab__site_width: "Width",
  site_summary_tab__site_length: "Length",
  site_summary_tab__total_area: "Total area",
  site_summary_tab__usable_area: "Usable area",
  site_summary_tab__parking: "Parking",
  site_summary_tab__primary_parking: "Primary parking",
  site_summary_tab__secondary_parking: "Secondary parking",
  site_summary_tab__motorbike_parking_capacity: "Motorbike parking capacity",
  site_summary_tab__parking_unit: "piece",
  site_summary_tab__site: "Site",
  site_summary_tab__site_description: "Site description",
  site_summary_tab__primary_site_surrounding_area:
    "Site surrounding area (primary)",
  site_summary_tab__secondary_site_surrounding_area:
    "Site surrounding area (secondary)",
  site_summary_tab__visibility: "Visibility",
  site_summary_tab__accessibility: "Accessibility",
  site_summary_tab__map_error:
    "Could not display site on map due to missing latitude, longitude",
  site_summary_tab__prediction: "Prediction",
  site_summary_tab__calculating: "Calculating",
  site_summary_tab__site_comparison: "Site comparison",
  site_summary_tab__investment_cost_and_break_even:
    "Investment cost & Break even point",

  site_information_tab__confirm_auto_geo:
    "Auto-generated latitude/longitude may be incorrect, please double check if needed. Do you want to continue?",
  site_information_tab__building: "Building",
  site_information_tab__auto_lat_lng: "Coordinates automatically",
  site_information_tab__show_map: "Show map",
  site_information_tab__hide_map: "Hide map",
  site_information_tab__characteristic: "Site characteristic",

  site_photo_tab__delete_photo: "Are you sure you want to delete this photo?",
  site_photo_tab__insert_photo: "Attach files",
  site_photo_tab__select_file: "Select file...",
  site_photo_tab__photo_guide_line: "Guideline",

  site_legal_document__download_template: "Download template",

  site_rental_information__time: "Time",
  site_rental_information__other: "Other rental information",
  site_rental_information__calculator: "Calculator",
  site_rental_information__select_calculator:
    "Choose how to calculate the rental price",
  site_rental_information__detail_calculator: "Calculator detail",
  site_rental_information__phone_number: "Phone number",
  site_rental_information__contact_placeholder: "Enter name or phone number",

  site_final_projection__area_target_population: "Total targeted population",
  site_final_projection__estimate_ticket_monthly: "Monthly ticket count (Est)",
  site_final_projection__average_ticket_value: "Average ticket size",
  site_final_projection__estimate_revenue_monthly: "Monthly revenue (Est)",
  site_final_projection__estimate_ebitda_monthly: "Monthly EBITDA (Est)",
  site_final_projection__trade_area_analysis: "Based on Trade Area Analysis",
  site_final_projection__store_sister: "Based on Sister Store Analysis",
  site_final_projection__select_store_sister: "Select sister store",
  site_final_projection__select_store_sister_placeholder: "Select a store",
  site_final_projection__operation_cost: "Operation costs",

  site_comment__filter_comment_by_status: "Filter by status",
  site_comment__comment_loading: "Loading comment...",
  site_comment__no_comment: "No comment",
  site_comment__loading: "Loading...",
  site_comment__loadmore: "Load more",
  site_comment__comment_placeholder: "Enter your comment...",
  site_comment__estimate_site_revenue: "Estimate site revenue",

  site_activity__activity: "Activity",
  site_activity__start: "Start",
  site_activity__end: "End",
  site_activity__note: "Notes",

  site_changlog__user: "User",

  store_listing__id: "ID",
  store_listing__city: "City",
  store_listing__store: "Store name",
  store_listing__contract_from: "Contract from",
  store_listing__contract_to: "Contract to",
  store_listing__active_month: "Active month",
  store_listing__search_name_placeholder: "Store name",
  store_listing__store_name: "Store name",
  store_listing__address: "Address",
  store_listing__store_id: "Internal code",
  store_listing__open_date: "Grand opening date",
  site_listing__deposit: "Deposit",
  site_listing__initial_lease_rate: "Initial lease rate",
  site_listing__payment_cycle: "Payment period",
  store_listing__contract_status: "Contract status",
  contract__active: "Active",
  contract__renew: "Renew",
  contract_tax: "Tax",

  store_detail__store_summary: "Store summary",
  store_detail__store_information: "Store information",
  store_detail__store_location: "Store location",
  store_detail__store_photo: "Photo",
  store_detail__store_legal: "Store legal information",
  store_detail__contact: "Contact",
  store_detail__update: "Update",

  site_cannibalization_modal__title: "Cannibalization rate forecast",
  site_cannibalization_modal__cannibalization_rate: "Cannibalization Rate",
  site_cannibalization_modal__cannibalization_rate_description:
    "is the % estimated revenue of the surrounding stores that will be lost if this store is opened (2km radius)",
  site_cannibalization_modal__calculating: "Calculating...",
  site_cannibalization_modal__distance: "Distance",
  site_cannibalization_modal__revenue_lost:
    "Revenue will be lost because of Cannibalization",
  site_cannibalization_modal__vnd_per_month: "VND / tháng",

  site_calculate_modal__title: "Calculate rental cost (whole site)",
  site_calculate_modal__years: "Years",
  site_calculate_modal__years_placeholder: "Số năm thuê",

  site_contact_modal__last_name: "Last name",
  site_contact_modal__middle_name: "Middle name",
  site_contact_modal__first_name: "First name",
  site_contact_modal__primary_phone: "Primary phone number",
  site_contact_modal__secondary_phone: "Secondary phone number",
  site_contact_modal__email: "Email",
  site_contact_modal__home_address: "Home address",
  site_contact_modal__work_address: "Work address",
  site_contact_modal__note: "Notes",
  site_contact_modal__customer_type: "Types of customer",
  site_contact_modal__select_an_option: "-- Select an option --",
  site_contact_modal_is_host: "Is this the home owner?",
  site_contact_modal_relationship_host: "Relationship with home owner",
  site_contact_modal_host: "Host",
  site_contact_modal_phone_number: "Phone number",

  city_picker__city: "City (*)",
  city_picker__district: "District (*)",
  city_picker__ward: "Ward (*)",
  site_activity_modal__title: "Site Activities",
  site_activity_modal__type_activity: "Types of activity",
  site_activity_modal__from: "From",
  site_activity_modal__to: "To",
  site_activity_modal__note: "Notes",

  site_contract_modal__title: "Create contract",
  site_contract_modal__edit: "Edit contract",
  site_contract_modal__view: "Contract",
  site_contract_modal__name: "Contract name",
  site_contract_modal__type: "Types of contract",
  site_tax__type: "Types of tax",
  site_contract_modal__date: "Contract signing date",
  site_contract_modal__start: "Contract valid date",
  site_contract_modal__expire: "Contract expiration date",
  site_contract_modal__rental_from: "Rental from",
  site_contract_modal__rental_to: "Rental to",
  site_contract_modal__month_expire: "Number of months remaining",
  site_contract_modal__pricing: "Rental cost (with tax)",
  site_contract_modal__payment_term: "Payment term",
  site_contract_modal__done_contract: "Completed contract",
  site_contract_modal__edit_contract: "Edit contract",
  site_contract_modal__view_contract: "View contract",
  site_contract_modal__delete_contract: "Delete contract",
  site_contract_modal__contract_info: "Contract Information",
  site_contract_modal__mark_as_rental_fee:
    "Used for contract rental calculation",
  site_contract_modal__remove_mark_as_rental_fee:
    "Remove Mark of Contract Used for Payment",
  site_contract_modal__contract_done: "Contract has been done",
  contract__payment_cycle: "Payment period",
  site_contract_modal__contract_number: "Contract number",
  site_contract_modal__rental_purpose: "Rental purpose",
  site_contract_modal__host_id: "Rental entity tax number",
  site_contract_modal__host_name: "Rental entity name",
  site_contract_modal__address: "Rental entity address",
  site_contract_modal__type_of_rent_calculation: "Type of rent calculation",
  site_contract_modal__period_type: "Period type",
  site_contract_modal__rent_time: "Lease term (month)",

  map__location: "Your location",
  map__getting_location: "Getting your location",
  map__search_placeholder: "Enter street name, location...",
  map__draw_potential_area: "Draw potential area",
  map__radius_mode: "Display F&B  and e-commerce demand by radius (Km)",
  map__radius_description: "Select position on map to show information",
  map__show_potential_area: "Show potential area",
  map__planning_zone_list: "Planning zone listing",
  map__type: "Types of map",
  map__people_unit: "people",
  map__population: "Area population",
  map__population_description: "Data from the General Statistics Office (2019)",
  map__show_area: "Show boundary",
  map__show_density_population: "Show density population",
  map__show_by_ward: "Display by Ward / Commune",
  map__show_by_district: "Display by District",
  map__age: "Age",
  map__unit_vnd: "dong",
  map__retail_demand: "Retail demand",
  map__avg_revenue: "Estimated average revenue in 3 months",
  map__show_on_map: "Show on map",
  map__unit_deal: "transaction",
  map__fb_demand: "F&B Demand",
  map__deal_from: "Data gathered from 11/2021 to 02/2022",
  map__fb_demand_type: "F&B Demand (dine in)",
  map__fb_demand_type_delivery: "F&B Demand (delivery)",
  map__no_data_yet: "No data yet",
  map__ecommerce_demand: "e-commerce demand",
  map__hide_all: "Hide all",

  settings__title: "Settings",
  settings__zone_management: "Zone Management",
  settings__user_management: "User Management",
  settings__status_management: "Status Management",
  settings__zone_configure: "Zone configure",
  settings__user: "Users",
  settings__custom_field: "Custom Field",

  zone_element__select_zone: "Select zone...",
  zone_element__setting_zone: "Zone setting",
  zone_element__assign_user: "Assign users",
  zone_element__edit_zone: "Edit zone",
  zone_element__select_zone_element: "Select element zone",
  zone_element__setting_user: "User setting",
  zone_element__assign_user_to_zone: "Assign user to zone",
  zone_element__create_new: "Create new zone",
  zone_element__name: "Name",
  zone_element__name_placeholder: "Enter zone name...",
  zone_element__zone_level: "Zone Level",
  zone_element__select_level: "Select level...",
  zone_element__city: "City",
  zone_element__district: "District",
  zone_element__ward: "Ward",

  setting_user__search_placeholder: "Enter name or username or email...",
  setting_user__search: "Search",
  setting_user__searching: "Searching...",
  setting_user__create_user: "Create user",
  setting_user__import_user: "Import user",
  setting_user__user_roles: "Roles",
  setting_user__zone: "Zone",
  setting_user__active: "Active",
  setting_user__brand_management: "Brand management",
  setting_user__reset_password: "Reset password",
  setting_user__password_is: "New password is",
  setting_user__import_title: "Import users",
  setting_user__download_template: "Download template",
  setting_user__role_assign_user: "Roles can be assign to users",
  setting_user__role_description:
    "When composing a template file, each user can have many roles separated by commas",
  setting_user__zone_assign_user: "Zones can be assign to users",
  setting_user__zone_description:
    "When composing a template file, each user can have multiple zones, the zones are separated by commas",
  setting_user__select_file_import: "Select file to import",
  setting_user__upload_create_user: "Upload and create user",

  setting_status__guide_create: "• Create new: Hold SHIFT and CLICK on screen",
  setting_status__guide_edit:
    "• Edit: select the Status to edit, then press the edit button",
  setting_status__guide_link:
    "• Create link: Hold SHIFT and drag from the first Status to the Status that needs to be linked",
  setting_status__create_new: "Create new Status",
  setting_status__edit: "Edit Status",
  setting_status__name: "Status name",
  setting_status__type: "Type of status",
  setting_status__order: "Status order",
  setting_status__role_can_update: "Role can be upgrade status",
  setting_status__role_default_assignment: "Default role to assign assignment",
  setting_status__show_on_progress_bar: "Show on progress bar",
  setting_status__site_status_default: "Default site status",
  setting_status__store_status_default: "Default store status",
  setting_status__site_can_edit: "Site can be edit",

  custom_tab__title: "Tab Listing",
  custom_tab__title_placeholder: "Tab name...",

  custom_tab_detail__title: "Group Listing",

  modal_create_tab__create_tab: "Create Tab",
  modal_create_tab__edit_tab: "Edit Tab",

  modal_create_group__create_group: "Create Group",
  modal_create_group__edit_group: "Edit Group",

  modal_create_field__create_field: "Create Field",
  modal_create_field__edit_field: "Edit Field",
  from_date: "From date",
  to_date: "To date",
  rental_fee: "Rental fee",
  rental_fee_percent: "Revenue share percentage",
  rental_fee_with_tax: "Rental fee with tax",
  current_rental_fee: "Rental fee (without tax)",
  current_rental_fee_with_tax: "Rental fee (with tax)",
  increase_fee_rate: "Increase fee rate",
  add_payment_term: "Add payment term",
  guide_line: "Guideline",
  contract: "Contract",
  financial_performance: "Financial performance",
  other_fee: "Other fees",
  deposit_method: "Deposit method",
  deposit_attribute_to_month: "Deposit attribute to month",
  management_fee: "Management fee",
  question: "Survey",
  contract_file: "Contract file",
  contract_file_payment: "Rental calculation file",
  contract_link: "Contract main",
  contract_deposit: "Deposit",
  contract_store_code: "Store code",

  revenue_current: "Revenue current month",
  revenue_last_12: "Revenue last 12 month",
  revenue: "Revenue",
  ebitda_current: "Ebitda current month",
  ebitda_last_12: "Ebitda last 12 month",
  ebitda: "Ebitda",
  renew_status: "Renew status",
  cannot_empty: "Can not be empty",
  empty_contract: (id: number) =>
    `Site has no rental contract, please go to <a class='link-text' href='/sitev2/${id}'>Site details</a> to create a rental contract`,

  terminate_reason: "Terminate reason",
  terminate_date: "Terminate date",
  error_no_permissions: "You do not have right permissions to perform this action.",
  error_something_went_wrong: "Whoops! Something went wrong! Please try again later.",
};
